import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { logger } from "../../utility/logger";

export const ProtectedRoute = ({ roles }) => {
  const { group } = useUser();

  /**VIKAS-
   * user group should belong to the atleast one role in the roles
   */
  if (!roles.some((role) => group.includes(role))) {
    logger.error("User is not authorized to access this tool");
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};
